"use strict";

import { getNamedContext } from "../getNamedContext.js";
export const HeaderBackContext = getNamedContext('HeaderBackContext', undefined);
//# sourceMappingURL=HeaderBackContext.js.map